import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import styles from "../AllServices.scss";

const cx = classnames.bind(styles);

const Section = ({ label, children }) => (
  <div className={cx("section")}>
    <h5 className={cx("section-label")}>{label}</h5>
    <div className={cx("section-content")}>{children}</div>
  </div>
);

Section.propTypes = {
  children: PropTypes.node,
  label: PropTypes.node,
};

export default Section;
